/**
 * Native feedback submit — client wire contract, PRIORITY 2.
 *
 * `apps/citizen-mobile/core/lib/feedback-upload.ts` posts multipart over a raw
 * `XMLHttpRequest` (built in app scope, because that is what yields parts
 * carrying `uri` on React Native) and then does:
 *
 *     try { return JSON.parse(text) as INativeFeedbackResponse; }
 *     catch { return {}; }
 *
 * POST /api/feedback
 *
 * WHAT THIS ONE CAN AND CANNOT SURVIVE
 * All three fields are already OPTIONAL in the phone's own interface, and a
 * parse failure degrades to `{}`. So a field going MISSING is survivable here —
 * unusually — and this schema says so rather than pretending otherwise.
 *
 * What is not survivable is a RETYPE. `attachments` arriving as `"2"` or
 * `delivered` as `"true"` parses cleanly, satisfies the `as` cast, and then
 * misbehaves in whatever reads it — the failure mode a truthiness check hides
 * completely, since `"false"` is truthy.
 *
 * Hence: every field optional, every field strictly typed.
 */
import { z } from 'zod';

export const clientWireFeedbackResponseSchema = z.object({
  id: z.string().optional(),
  /** A BOOLEAN. `"false"` is truthy — a string here is worse than a missing field. */
  delivered: z.boolean().optional(),
  /** A NUMBER, not a string: it is rendered as a count. */
  attachments: z.number().optional(),
});

export type ClientWireFeedbackResponse = z.infer<typeof clientWireFeedbackResponseSchema>;
